<template>
    <div class="z-bms">
        <div class="max-title lineheight_32 fz-24">遥信</div>
        <div class="mild" v-if="bmsdata.mild && bmsdata.mild.length>0">
            <div class="title">
                <img src="/static/images/svolt/mild.png" />
                <span>轻度报警</span>
            </div>
            <el-row class="content">
                <el-col v-for="(item, index) in bmsdata.mild" :key="index" :span="6">
                    <el-tooltip :content="item.name" :disabled="item.name.length < 15" placement="top">
                        <span class="data-name" :class="{ red: item.value == '1' }">{{ item.name }}</span>
                    </el-tooltip>
                </el-col>
            </el-row>
        </div>

        <div class="mild" v-if="bmsdata.moderate && bmsdata.moderate.length>0">
            <div class="title">
                <img src="/static/images/svolt/moderate.png" />
                <span style="color:#FA6400">中度报警</span>
            </div>
            <el-row class="content">
                <el-col v-for="(item, index) in bmsdata.moderate" :key="index" :span="6">
                    <el-tooltip :content="item.name" :disabled="item.name.length < 15" placement="top">
                        <span class="data-name" :class="{ red: item.value == '1' }">{{ item.name }}</span>
                    </el-tooltip>
                </el-col>
            </el-row>
        </div>

        <div class="mild" v-if="bmsdata.severe && bmsdata.severe.length>0">
            <div class="title">
                <img src="/static/images/svolt/severe.png" />
                <span style="color:#FF2746">重度报警</span>
            </div>
            <el-row class="content">
                <el-col v-for="(item, index) in bmsdata.severe" :key="index" :span="6">
                    <el-tooltip :content="item.name" :disabled="item.name.length < 15" placement="top">
                        <span class="data-name" :class="{ red: item.value == '1' }">{{ item.name }}</span>
                    </el-tooltip>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        bmsdata: {
            type: Object,
            default() {
                return { mild: [], moderate: [], severe: [] };
            }
        }
    },
    created() {},
    mounted() {},
    methods: {}
};
</script>

<style lang="scss" scoped>
.z-bms {
    margin: 0px 10px;
    .max-title {
        padding: 10px;
        margin: 0 10px;
        text-align: center;
        color: #389bc7;
        font-weight: bold;
    }
    .title {
        img {
            width: 22px;
            height: 18px;
            display: inline-block;
        }
        span {
            height: 21px;
            font-size: 18px;
            font-family: 微软雅黑;
            font-weight: bold;
            color: #f7b500;
            line-height: 21px;
            display: inline-block;
            margin-top: 2px;
        }
    }
    .content {
        margin-top: 15px;
        height: 80%;
        overflow-y: auto;
        .data-name {
            margin: 10px 10px;
            display: inline-block;
            background: #00c000;
            border-radius: 2px;
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: #ffffff;
            padding: 8px 5px;
            width: 90%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
    .mild {
        height: 205px;
        overflow-y: hidden;
        border: 0px dotted #004fa9;
        padding: 20px;
        margin-bottom: 20px;
        background: #f7f7f7;
    }
    .red {
        background: #ff2746 !important;
    }
    .fz-24{
      font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/wiring-diagram/bms.vue